export const MAX_IMPORT_RECORDS = 2000;

export type CsvImportField = {
  key: string;
  label: string;
  required?: boolean;
};

export type CsvFieldMapping = Record<string, string | undefined>;

export type CsvImportResponse = {
  blob: Blob;
  metadata?: {
    data?: {
      total?: number;
      successful?: number;
      failed?: number;
    };
  } | null;
};

export type CsvImportRequest = (
  data: { data: any[] },
  accessToken: string,
  options?: { timeoutMs?: number }
) => Promise<CsvImportResponse>;

function normalize(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]/g, "");
}

function scoreMatch(field: CsvImportField, header: string): number {
  const candidates = [field.key, field.label].map(normalize);
  const normalizedHeader = normalize(header);
  let bestScore = 0;

  for (const candidate of candidates) {
    if (candidate === normalizedHeader) return 2;
    if (candidate.includes(normalizedHeader) || normalizedHeader.includes(candidate)) {
      bestScore = Math.max(
        bestScore,
        Math.min(candidate.length, normalizedHeader.length) /
          Math.max(candidate.length, normalizedHeader.length)
      );
    }
  }
  return bestScore;
}

export function autoMapCsvFields(
  fields: CsvImportField[],
  headers: string[]
): CsvFieldMapping {
  const mapping: CsvFieldMapping = {};
  const claimed = new Set<string>();

  for (const field of fields) {
    let bestHeader = "";
    let bestScore = 0;
    for (const header of headers) {
      if (claimed.has(header)) continue;
      const score = scoreMatch(field, header);
      if (score > bestScore) {
        bestHeader = header;
        bestScore = score;
      }
    }
    if (bestScore > 0) {
      mapping[field.key] = bestHeader;
      claimed.add(bestHeader);
    }
  }

  return mapping;
}

export function mappedCsvValue(
  row: Record<string, string>,
  mappings: CsvFieldMapping,
  key: string
): string | null {
  const column = mappings[key];
  return column ? row[column]?.trim() || null : null;
}
